module.exports = __webpack_public_path__ + "img/zf_tab_2-1.8ce6d70c.png";